"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createBreakpointMediaQueries = exports.breakpointMediaQuery = void 0;
const breakpointMediaQuery = function (_ref) {
  let {
    min,
    max,
    direction
  } = _ref;
  const query = [];
  if (min && direction !== "down") {
    query.push(`(min-width: ${min}px)`);
  }
  if (max && direction !== "up") {
    query.push(`(max-width: ${max}px)`);
  }
  if (query.length === 0) {
    return "@media ";
  }
  return `@media ${query.join(" and ")}`;
};
exports.breakpointMediaQuery = breakpointMediaQuery;
const createBreakpointMediaQueries = function (breakpoints) {
  return function (point, direction) {
    let min;
    let max;
    if (point === "tablet") {
      min = breakpoints.mobile + 1;
      max = breakpoints.tablet;
    } else if (point === "desktop") {
      min = breakpoints.tablet + 1;
      max = breakpoints.desktop;
    } else if (point === "xldesktop") {
      min = breakpoints.desktop + 1;
    } else {
      max = breakpoints.mobile;
    }
    return breakpointMediaQuery({
      min,
      max,
      direction
    });
  };
};
exports.createBreakpointMediaQueries = createBreakpointMediaQueries;
var _default = exports.default = breakpointMediaQuery;